<div  class="display-block position-relative" 
      cdkDropList 
      (cdkDropListDropped)="documentDrop($event)"
>

  <ss-document-item 
    *ngFor="let pdfDocument of (pdfDocumentsSubject | async);trackBy:trackById;let idx = index;"
    [idx]="idx" [pdfDocument]="pdfDocument"
    class="margin-small-bottom display-block"
  ></ss-document-item>

  <ss-core-loader-outlet [keys]="['document.load','document.insert','document.remove','document.reorder']"></ss-core-loader-outlet>
</div>